import router from '@/modules/cart/router'
import CartApi from '@/modules/cart/service'
import { useCartStore } from '@/modules/cart/store'

export default {
  store: useCartStore,
  service: new CartApi(),
  router,
}
